import { styled } from '@health-zelas/delta'

export const FieldGroup = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '$xxs',
  marginBottom: '$sm'
})
